import { ArrowUpRight, Instagram } from 'lucide-react'
import Parallax from './Parallax'
import Reveal from './layout/Reveal'

const INSTAGRAM_PROFILE = 'https://www.instagram.com/merrittandshawn/'

const InstagramFeed = () => (
  <section id="instagram" className="relative overflow-hidden bg-primary-mist py-20 text-primary-ink md:py-32">
    <div className="coastal-orbit coastal-orbit-reverse pointer-events-none absolute -right-48 top-1/4 h-[34rem] w-[34rem] rounded-full border border-primary-navy/15 motion-reduce:animate-none" aria-hidden="true" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-[0.78fr_1.22fr] lg:gap-20">
      <Reveal>
        <div className="max-w-xl">
          <div className="flex items-center gap-4 text-primary-ink">
            <span className="h-px w-10 bg-accent-gold" aria-hidden="true" />
            <p className="font-sans text-[10px] font-medium uppercase tracking-[0.28em]">Latest from @merrittandshawn</p>
          </div>
          <Parallax axis="x" factor={0.04} max={22}>
            <h2 className="mt-7 font-serif text-[clamp(3.8rem,7vw,7rem)] font-normal leading-[0.86] tracking-[-0.055em]">
              Life at the <span className="italic text-primary-navy">coast.</span>
            </h2>
          </Parallax>
          <p className="mt-8 max-w-lg text-base font-light leading-[1.9] text-primary-ink/70 md:text-lg">
            New listings, local places, renovations, and the everyday moments that make Coastal Delaware home. This view updates automatically whenever Merritt and Shawn share on Instagram.
          </p>
          <a
            href={INSTAGRAM_PROFILE}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Merritt and Shawn on Instagram"
            className="instagram-follow relative mt-9 inline-flex min-h-16 min-w-[19rem] max-w-full items-center overflow-hidden rounded-full border border-primary-ink/15 bg-primary-ink p-1.5 pr-2 text-white shadow-[0_16px_40px_rgba(22,50,71,0.18)] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-gold focus-visible:ring-offset-4 focus-visible:ring-offset-primary-mist"
          >
            <span className="instagram-follow-fill pointer-events-none absolute inset-0 bg-accent-gold" aria-hidden="true" />
            <span className="instagram-follow-shine pointer-events-none absolute inset-y-0 left-0 w-16 -skew-x-12 bg-gradient-to-r from-transparent via-white/35 to-transparent" aria-hidden="true" />
            <span className="instagram-follow-icon relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-gold text-primary-ink">
              <span className="instagram-follow-ring pointer-events-none absolute -inset-1 rounded-full border border-b-accent-gold/30 border-l-transparent border-r-transparent border-t-accent-gold" aria-hidden="true" />
              <Instagram size={20} strokeWidth={1.8} className="relative z-10" aria-hidden="true" />
            </span>
            <span className="relative z-10 flex min-w-0 flex-1 flex-col px-3 text-left font-sans uppercase">
              <span className="instagram-follow-eyebrow text-[7px] font-medium tracking-[0.2em] text-white/50">Follow the coastal story</span>
              <span className="instagram-follow-handle mt-1 truncate text-[11px] font-medium tracking-[0.13em] text-white">@merrittandshawn</span>
            </span>
            <span className="instagram-follow-arrow relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/20 text-accent-gold">
              <ArrowUpRight size={16} strokeWidth={1.8} aria-hidden="true" />
            </span>
          </a>
        </div>
      </Reveal>

      <Reveal delay={120} className="min-w-0">
        <div className="group relative mx-auto w-full max-w-[620px]">
          <span className="instagram-feed-corner pointer-events-none absolute -left-3 -top-3 z-10 h-24 w-24 border-l-2 border-t-2 border-accent-gold" aria-hidden="true" />
          <span className="instagram-feed-corner pointer-events-none absolute -bottom-3 -right-3 z-10 h-24 w-24 border-b-2 border-r-2 border-accent-gold" aria-hidden="true" />
          <div className="instagram-feed-frame relative overflow-hidden bg-primary-ink shadow-[0_30px_80px_rgba(22,50,71,0.22)]">
            <div data-instagram-window className="relative aspect-[3/2] overflow-hidden bg-primary-ink">
              <iframe
                src="https://www.instagram.com/merrittandshawn/embed/"
                title="Latest Instagram posts from Merritt and Shawn"
                loading="lazy"
                scrolling="no"
                referrerPolicy="strict-origin-when-cross-origin"
                className="absolute -top-[165px] left-0 h-[calc(100%+250px)] w-full border-0 sm:-top-[158px]"
              />
            </div>
          </div>
          <div className="mt-5 flex items-center justify-between gap-4 font-sans text-[8px] font-medium uppercase tracking-[0.2em] text-primary-ink/50">
            <span className="inline-flex items-center gap-2"><span className="instagram-feed-pulse h-1.5 w-1.5 rounded-full bg-accent-gold" aria-hidden="true" /> Live from Instagram</span>
            <span>Latest six posts</span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
)

export default InstagramFeed
